<template>
    <g>
        <circle fill="#fff" cx="6" cy="7" r="6">
            <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin=".1"></animate>
        </circle>
        <circle fill="#fff" cx="26" cy="7" r="6">
            <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin=".2"></animate>
        </circle>
        <circle fill="#fff" cx="46" cy="7" r="6">
            <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin=".3"></animate>
        </circle>
    </g>
</template>

<script>
    export default {
        name: 'loaderIcon',
        beforeMount() {
            this.$parent.$emit('size', '0 0 52 14');
        }
    };
</script>

<style scoped>

</style>
